import { Map } from "immutable";
import { combineReducers } from "redux";
import { FETCH_CONVERSATION_MESSAGES_SUCCESS, FETCH_ACTIVITY_LOGS_SUCCESS } from "~/store/action_types";

const conversations = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_CONVERSATION_MESSAGES_SUCCESS: {
      const { conversationId, responseHeaders = {} } = action;
      const cursor = responseHeaders["x-angie-paginationnextcursor"] || "";
      const id = responseHeaders["x-angie-paginationlastid"] || "";

      if (conversationId) {
        return state.set(
          `${conversationId}`,
          Map({
            cursor: cursor.length ? parseInt(cursor) : null,
            lastId: id.length ? parseInt(id) : null,
          })
        );
      }

      return state;
    }
    default:
      return state;
  }
};

const activityLogs = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_ACTIVITY_LOGS_SUCCESS: {
      const { activityType = "", responseHeaders = {} } = action;

      if (typeof activityType === "string" && activityType.length) {
        const cursor = responseHeaders["x-angie-paginationnextcursor"] || "";
        return state.set(`${activityType}`, cursor.length ? parseInt(cursor) : null);
      }

      return state;
    }
    default:
      return state;
  }
};

export default combineReducers({
  conversations,
  activityLogs,
});
